import { ChangePasswordInjection } from "features/changePassword/di/ChangePasswordInjection";
import React from "react";
import { getMessage } from "utils/helpersInTs/helpersInTs";
import { strings } from "utils/localizedStrings";

const ChangePasswordViewModel = (onCLose: () => void) => {
  const [loading, setLoading] = React.useState<boolean>(false);

  const onSubmit = async (values: any) => {
    try {
      setLoading(true);
      const useCase = ChangePasswordInjection.getUseCase();
      const res = await useCase.changePassword({
        new: values?.password ?? undefined,
        old: values?.oldPassword ?? undefined,
      });
      if (res?.data) {
        getMessage(strings.GlobalMessage.UpdateSuccessfully, 4, "success");
        onCLose();
      }
    } catch (err) {
      console.error(err);
      getMessage(err && err?.message, 4, "error");
    } finally {
      setLoading(false);
    }
  };

  return {
    onSubmit,
    submitLoading: loading,
  };
};

export default ChangePasswordViewModel;
